import { createUseStyles } from "react-jss";
import {
  pageContentRoot,
  pageHeaderRow,
  pageShellRoot,
} from "../../styles/pageShell";

/*
 * `divApercu`, `divApercuFilter`, `divApercu2` and `divFilter` were removed:
 * nothing in Department.tsx referenced them, and `divApercu` in particular
 * was pinned with `position: absolute; top: 125px; right: 320px`, which would
 * have landed anywhere but the intended spot on a non-desktop viewport.
 */
const useStyles = createUseStyles({
  contentMain: pageShellRoot,

  containerHeader: {
    ...pageHeaderRow,
    padding: "15px 0px",
  },

  vehiculeRoot: pageContentRoot,

  /* Back-arrow + page title. `minWidth: 0` so a long department name
     truncates instead of shoving the action button off-screen. */
  divIconArrow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "16px",
    minWidth: 0,
    flex: "1 1 auto",
  },
});

export default useStyles;
